export default __webpack_public_path__ + "static/media/prensa-rosin-automatica.d094319f.jpg";